
/**
 * Module dependencies.
 */

import { Icon } from 'react-components/media';
import { prop } from 'styled-tools';
import { useBreakpoint } from '../breakpoint';
import maskDesktopIcon from './assets/svg/mask/mask.svg';
import maskMobileIcon from './assets/svg/mask/mask-mobile.svg';
import shadowedMaskDesktopIcon from './assets/svg/mask/shadowed-mask.svg';
import shadowedMaskMobileIcon from './assets/svg/mask/shadowed-mask-mobile.svg';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  color?: string;
  hasShadow?: boolean;
  icon?: string;
  iconSize?: string;
  size?: string;
};

/**
 * `MaskedIconWrapper` styled component.
 */

const MaskedIconWrapper = styled.div<{ size: string }>`
  display: inline-block;
  height: ${prop('size')};
  position: relative;
  width: ${prop('size')};
`;

/**
 * `CenteredIcon` styled component.
 */

const CenteredIcon = styled(Icon)`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;

/**
 * Export `MaskedIcon` component.
 */

export function MaskedIcon(props: Props): JSX.Element {
  const { className, color, hasShadow = true, icon, iconSize, size } = props;
  const isDesktop = useBreakpoint('ms', 'min');
  const maskIcon = isDesktop ? maskDesktopIcon : maskMobileIcon;
  const shadowedMaskIcon = isDesktop ? shadowedMaskDesktopIcon : shadowedMaskMobileIcon;
  const iconsSize = iconSize ?? (isDesktop ? '120px' : '56px');

  return (
    <MaskedIconWrapper
      className={className}
      size={iconsSize}
    >
      <Icon
        aria-hidden
        icon={hasShadow ? shadowedMaskIcon : maskIcon}
        size={iconsSize}
      />

      <CenteredIcon
        aria-hidden
        color={color}
        icon={icon}
        size={size ?? (isDesktop ? '56px' : '24px')}
      />
    </MaskedIconWrapper>
  );
}
